import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Struct } from "../codec/Struct.mjs";
/**
 * @name GenericBlock
 * @description
 * A block encoded with header and extrinsics
 */

export var GenericBlock =
/*#__PURE__*/
function (_Struct) {
  _inherits(GenericBlock, _Struct);

  function GenericBlock(registry, value) {
    _classCallCheck(this, GenericBlock);

    return _possibleConstructorReturn(this, _getPrototypeOf(GenericBlock).call(this, registry, {
      header: 'Header',
      // eslint-disable-next-line sort-keys
      extrinsics: 'Vec<Extrinsic>'
    }, value));
  }
  /**
   * @description Encodes a content [[Hash]] for the block
   */


  _createClass(GenericBlock, [{
    key: "contentHash",
    get: function get() {
      return this.registry.hash(this.toU8a());
    }
    /**
     * @description The [[Extrinsic]] contained in the block
     */

  }, {
    key: "extrinsics",
    get: function get() {
      return this.get('extrinsics');
    }
    /**
     * @description Block/header [[Hash]]
     */

  }, {
    key: "hash",
    get: function get() {
      return this.header.hash;
    }
    /**
     * @description The [[Header]] of the block
     */

  }, {
    key: "header",
    get: function get() {
      return this.get('header');
    }
  }]);

  return GenericBlock;
}(Struct);